// extracted by mini-css-extract-plugin
export default {"analyzerBox":"callsTab_analyzerBox__NOm9V","tag":"callsTab_tag__Jrb-c","outlook":"callsTab_outlook__yFm4a","status":"callsTab_status__ynfNW"};